import styled from 'styled-components';
import type { BoxProps } from './Box';
import { Flex } from './Flex';

/** Simple flex div with 'flex-direction: row' and centered content
 *
 * Set flex properties without creating a new component.
 *
 * Default Props:
 * - justifyContent: 'center'
 * - alignItems: 'center'
 */
export const HStack = styled(Flex)<BoxProps>`
  flex-direction: row;
`;

HStack.defaultProps = {
  justifyContent: 'center',
  alignItems: 'center',
};
